import { render, staticRenderFns } from "./ConferenceRoomScreenV2.vue?vue&type=template&id=47f1b758&scoped=true"
import script from "./ConferenceRoomScreenV2.vue?vue&type=script&lang=js"
export * from "./ConferenceRoomScreenV2.vue?vue&type=script&lang=js"
import style0 from "./ConferenceRoomScreenV2.vue?vue&type=style&index=0&id=47f1b758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f1b758",
  null
  
)

export default component.exports